module.exports = __webpack_public_path__ + "img/enceinte-assise.48d47386.png";